module.exports = __webpack_public_path__ + "assets/img/shanghai.909a7c5c.png";